import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { TYPE_LIST } from '../../_utils/data';
import { useUpdateTypeSelection } from '@/hooks/useUpdateTypeSelection';
import { FormattedMessage } from 'react-intl';
import { Image } from '@/components/Image';
import { trackEvent } from '@/components/Event/_lib/eventTrack';

const FILTER_NAME_DEFAULTS: Record<string, string> = {
  all: 'All types',
  '1': 'Album',
  '2': "Season's Greeting",
  '3': 'Fan Sign',
  '4': 'Fan Meeting',
  '5': 'Fan Club',
  '6': 'Concert',
  '7': 'MD',
  '8': 'Collabo',
  '9': 'Benefit',
  '10': 'Etc'
};

export default function TypeSection() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { updateTypeSelection } = useUpdateTypeSelection();
  const type = searchParams.get('category')?.split(',') ?? ['all'];

  const handleClick = (name: string, title: string) => {
    updateTypeSelection(name, type);

    const isActive = !type.includes(name) || (type.length === 1 && name === type[0]) ? 'active' : 'inactive';
    trackEvent('PLP_click_Filter', { type: title, is_active: isActive });
  };

  const handleResetClick = () => {
    searchParams.delete('category');
    navigate(`${location.pathname}?${searchParams}`);
  };

  return (
    <section className="absolute top-[62px] left-0 z-10 bg-white w-full h-[190px] [box-shadow:0px_7px_3px_-2px_rgba(94,94,94,0.2)]">
      <div className="w-full flex justify-between items-center border-t border-b border-[#f5f5f5] pr-[37px] pl-5 py-4 text-[16px] leading-6 font-semibold">
        <span className="text-black">
          <FormattedMessage id="type" defaultMessage="Type" />
        </span>
        <span className="flex gap-1 items-center text-[#808080] cursor-pointer" onClick={handleResetClick}>
          <Image src="/icons/reset.svg" alt="reset-svg" width={16} />
          <FormattedMessage id="reset" defaultMessage="Reset" />
        </span>
      </div>

      <div className="flex flex-wrap gap-3 px-5 py-4">
        {TYPE_LIST.map((data) => (
          <div
            className={`flex justify-center items-center cursor-pointer py-2 px-5 rounded-[10px] text-[16px] leading-6 font-semibold ${
              type.includes(data.name)
                ? 'border border-black text-white bg-black'
                : 'border border-[#ededed] text-[#bfbfbf] bg-white'
            }`}
            key={`type_${data.name}`}
            onClick={() => {
              handleClick(data.name, data.title);
            }}
          >
            <p className="">
              <FormattedMessage id={`filter_name_${data.name}`} defaultMessage={FILTER_NAME_DEFAULTS[data.name] ?? ''} />
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
